import { EventEmitter, Output } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OwnershipTypeDto, LessorsDto, TerrainDto, BankDto,
  LessorRepTypeDto, MeasureDto, LossOfUseItemsDto, AddressBookDto, IndividualAcreagesDto, LessorRepresentativeDto, LessorInfoDto, LessorStakeholderDto, UomDto, } from '@cradua/data';
import { Guid } from 'guid-typescript';
import Swal from 'sweetalert2';
import { LessorModalComponent } from './lessor-modal/lessor-modal.component';


@Component({
  selector: 'cradua-bulkandsurfaceright',
  templateUrl: './bulkandsurfaceright.component.html',
  styleUrls: ['./bulkandsurfaceright.component.css']
})
export class BulkandsurfacerightComponent implements OnInit {
  @Output() submitevent = new EventEmitter();
  @Output() searchEvent = new EventEmitter();
  @Output() addressssearchevent = new EventEmitter();
  @Output() deleteEvent = new EventEmitter();
  paymentForm: FormGroup;
  @Input() ownershiptypes: OwnershipTypeDto[];
  @Input() quantums: any[];
  @Input() lessors: LessorsDto[];
  @Input() terrains: TerrainDto[];
  @Input() lossofuseitems: LossOfUseItemsDto[];
  @Input() measures: UomDto[];
  @Input() addressbooks: AddressBookDto[];
  @Input() lessorInfos: LessorInfoDto[];
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Input() lessorStakeholders: LessorStakeholderDto[];
  @Input() banks: BankDto[];
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input()  individualAcreages: IndividualAcreagesDto[];
  @Input() PaymentType: any;
  @Input() LandTitleSerialNo: string;
  filteredPayment = [];
  lessorType: string;
  listView = true;
  gridView = false;
  filteredDelete = [];

  totalAmount = 0;
  negotiatedAmount = 0;
    constructor(
      private fb: FormBuilder,
      private matSnackBar: MatSnackBar,
      public dialog: MatDialog,
      ) { }

    ngOnInit(): void {
    this.addPayment();

      this.setPayment();
    }

    ngOnChanges(): void {
      this.setPayment();
    }

    onList() {
      this.listView = true;
      this.gridView = false;
    }

    onGrid() {
      this.gridView = true;
      this.listView = false;
    }

    selectPayment(payment) {

      if(!payment.isNew) {
        this.paymentForm.patchValue({isNew: false});
      }
      this.paymentForm.patchValue(payment);
    }

    getUomName(id: string) {
      return this.measures.find(measure => measure.id === id)?.UomName || null;
    }

    onLessorDialog(type: string) {

      const dialogConfig = new MatDialogConfig();

      // dialogConfig.disableClose = false;
      dialogConfig.id = "lessor-modal-component";
      dialogConfig.height = "90%";
      dialogConfig.width = "100%";


      dialogConfig.data = {
        lessorInfos: this.lessorInfos,
        lessorRepresentatives: this.lessorRepresentatives,
        lessorRepTypes: this.lessorRepTypes,
        lessorStakeholders: this.lessorStakeholders,
        addressBooks: this.addressbooks,
        individualAcreages: this.individualAcreages,
        banks: this.banks,
        terrains: this.terrains,
        measures: this.measures,
        type,
      }
      const dialogRef = this.dialog.open(
        LessorModalComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result: any) => {
        // this.selectedAddressBook = result;
        if(result != null && type === 'lessorInfo') {
          // console.log('return lessor info ', result);
          this.lessorType = result?.type;
          this.paymentForm.patchValue({
          OwnershipTypeId: result?.lessorInfo?.OwnershipTypeId,
          Owners: result?.lessorInfo?.AddressBookId,
          ownerName: result?.lessorInfo?.AccountName,
          OwnershipTypeName: result?.lessorInfo?.OwnershipTypeName,
          TerrianName: this.getTerrain(result?.acreage?.TerrainId),
            LandType: result?.acreage?.TerrainId,
            Terrain_TerrainId: result?.acreage?.TerrainId,
            Area: result?.acreage?.NetArea,
          });
          this.calcAmount();
          // this.paymentForm.patchValue({
          //   TerrianName: this.getTerrain(result?.acreage?.TerrainId),
          //   LandType: result?.acreage?.TerrainId,
          //   Terrain_TerrainId: result?.acreage?.TerrainId,
          // });

        } else if(result != null && type === 'representative') {
          this.lessorType = result?.type;
          const lessorInfo = this.getLessorInfo(result?.representative?.LessorsId);
          this.paymentForm.patchValue({
          OwnershipTypeId: lessorInfo?.OwnershipTypeId,
          Owners: result?.representative?.AddressBookId,
          LandType: lessorInfo?.TerrainId,
          ownerName: result?.representative?.addressBook?.Name,
          OwnershipTypeName: lessorInfo?.OwnershipTypeName,
          });
        } else if(result != null && type === 'stakeholder') {
          this.lessorType = result?.type;
          const lessorInfo = this.getLessorInfo(result?.representative?.LessorsId);
          this.paymentForm.patchValue({
          OwnershipTypeId: lessorInfo?.OwnershipTypeId,
          Owners: result?.representative?.AddressBookId,
          LandType: lessorInfo?.TerrainId,
          ownerName: result?.representative?.addressBook?.Name,
          OwnershipTypeName: lessorInfo?.OwnershipTypeName,
          });
        }

      });
    }

    getTerrain(id: string) {
      return this.terrains.find(terrain => terrain.id === id)?.TerrainName || null;
    }


    onLossOfUseDialog(type: string) {

      const dialogConfig = new MatDialogConfig();

      // dialogConfig.disableClose = false;
      dialogConfig.id = "lessor-modal-component";
      dialogConfig.height = "90%";
      dialogConfig.width = "100%";


      dialogConfig.data = {
        lossOfUseItems: this.lossofuseitems,
        type,
      }
      const dialogRef = this.dialog.open(
        LessorModalComponent,
        dialogConfig,
      );

      dialogRef.afterClosed().subscribe((result: any) => {
        // this.selectedAddressBook = result;
        if(result != null && type === 'lossOfUse') {
          this.paymentForm.patchValue({
            Rate: result?.Rate,
            UomId: result?.UomId,
            MeasureName: result?.UomName,
            ItemName: result?.LossOfUseItemDesc
          });

            this.calcAmount();
        }

      });
    }

  getLessorInfo(id: string): LessorInfoDto {
    return this.lessorInfos.find(lessor => lessor.id === id) || null;
  }

setPayment() {
  this.lessors = this.lessors.filter(a => a.PaymentType === this.PaymentType && (this.LandTitleSerialNo === a.LandTitleSerialNo && a.Payment ==='Acreages'));
 this.filteredPayment =  this.lessors.map(e => {
   return {
     OwnershipTypeId: e.OwnershipTypeId,
     Owners: e.Owners,
     LandType: e.LandType,
     Status: e.Status,
     isNew: false,
     Area: e.Area,
     Rate: e.Rate,
     Amount: e.Amount,
     Remarks: e.Remarks,
     LandTitleSerialNo: e.LandTitleSerialNo,
     ItemName: e.ItemName,
     Type: e.Type,
     ApprovalStatus: e.ApprovalStatus,
     PaymentStatus: e.PaymentStatus,
     NegotiatedAmount: e.NegotiatedAmount,
     LossOfUseItemId: e.LossOfUseItemId,
     MeasureId: e.MeasureId,
     ApprovalRemarks: e.ApprovalRemarks,
     Ra: e.Ra,
     DistributorFactorValue: e.DistributorFactorValue,
     DistributorFactorName: e.DistributorFactorName,
     Rdf: e.Rdf,
     Terrain_TerrainId: e.Terrain_TerrainId,
     AddressBook_AddressBookId: e.AddressBook_AddressBookId,
     PaymentType: e.PaymentType,
     ownerName: e.ownerName,
     BulkPaymentStatus_text: e.BulkPaymentStatus_text,
     BulkPaymentStatus_value: e.BulkPaymentStatus_value,
     OwnershipTypeName: e.OwnershipTypeName,
     Payment: e.Payment,
     TerrianName: e.TerrianName,
     UomId: e.UomId,
     MeasureName: e.MeasureName,
     IncidentQuantumId: e.IncidentQuantumId,
     id: e.id,
   };
  });
}
    addPayment() {
      this.paymentForm =  this.fb.group({
        id: Guid.create().toString(),
        OwnershipTypeId: ['', Validators.required],
        Owners: [''],
        LandType: [''],
        Status: [''],
        Area: [0, Validators.required],
        Rate: [0, Validators.required],
        Amount: [0, Validators.required],
        Remarks: [''],
        LandTitleSerialNo: [this.LandTitleSerialNo],
        ItemName: [''],
        Type: ['BK'],
        ApprovalStatus: [''],
        PaymentStatus: ['PENDING'],
        NegotiatedAmount: [0, Validators.required],
        LossOfUseItemId: [''],
        MeasureId: [''],
        ApprovalRemarks: [''],
        Ra: [''],
        DistributorFactorValue: [''],
        DistributorFactorName: [''],
        isNew: true,
        Rdf: [false],
        Terrain_TerrainId: ['', Validators.required],
        AddressBook_AddressBookId: [''],
        PaymentType: [this.PaymentType],
        Payment: 'Acreages',
        ownerName: ['', Validators.required],
        BulkPaymentStatus_text: [''],
        BulkPaymentStatus_value: [''],
        OwnershipTypeName: ['', Validators.required],
        TerrianName: ['', Validators.required],
        UomId: [''],
        MeasureName: ['', Validators.required],
        IncidentQuantumId: [''],

      });
      }

      selectaddressbook(book: AddressBookDto) {

        this.paymentForm.patchValue({
          ownerName: book.Name,
          Owners: book.id
        });
      }

      selectImpact(quantum) {

        this.paymentForm.patchValue({
          // Area: quantum.DistributorFactorName,
          DistributorFactorName: quantum.DistributorFactorName,
          DistributorFactorValue: quantum.DistributorFactorValue,
          IncidentQuantumId: quantum.id
        })
        this.calcAmount();
       }

       getImpact(lessor) {
        return this.quantums.find(impact => impact.id === lessor.IncidentQuantumId);
       }
       selectLossOfItem(item: LossOfUseItemsDto) {
         this.paymentForm.patchValue({
          Rate: item.Rate,
          UomId: item.UomId,
          MeasureName: item.UomName
        });

          this.calcAmount();
       }

       calcAmount() {

        let amount = 0;
        if(this.paymentForm.value.DistributorFactorValue) {
           amount = this.paymentForm.value.Rate * this.paymentForm.value.Area * +this.paymentForm.value.DistributorFactorValue;
        } else {
           amount = this.paymentForm.value.Rate * this.paymentForm.value.Area;
        }


        this.paymentForm.patchValue({
          NegotiatedAmount: amount,
          Amount: amount
        });
       }

       calcTotal() {
        const amount = {
          totalAmount: 0,
          totalNegotiated: 0
         }

        this.filteredPayment.map((a) => {
          amount.totalAmount += a.Amount;
          amount.totalNegotiated += a.NegotiatedAmount;
        });

        return amount;
       }

      searchAddressbook(name: string) {
       this.addressssearchevent.emit(name)
      }

        selectTerrain(terrain: TerrainDto, i: number) {
          this.paymentForm.patchValue({
            TerrianName: terrain.TerrainName,
            LandType: terrain.id,
            Terrain_TerrainId: terrain.id
          });

        }

        selectOwnershipType(ownertype: OwnershipTypeDto, i) {
          this.paymentForm.patchValue({
            OwnershipTypeName: ownertype.OwnershipTypeName,
          });
        }

        deleteLessor(data) {
          Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this imaginary file!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it'
          }).then((result) => {
            if (result.value) {

        this.filteredPayment = this.lessors.filter(lessor => lessor.id !== data.id);

        if(data.id && !data.isNew) {
          this.deleteEvent.emit(data.id);
        }

        Swal.fire(
                'Deleted!',
                'Your imaginary file has been deleted.',
                'success'
              );
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire(
                  'Cancelled',
                  'Your imaginary file is safe :)',
                  'error'
                );
              }
            });
        }



        savePayment(lessor) {
          // console.log('lessor', lessor);
          if(this.paymentForm.valid) {
              this.paymentForm.reset();
              this.addPayment();
              this.filteredPayment = this.filteredPayment.filter(les => les.id !== lessor.id);
              this.filteredPayment.unshift(lessor);
          } else {
            this.matSnackBar.open('please fill all required fields!', 'Exit', {duration: 3000});
          }
        }

      onSubmit(data) {
        const mapData = [];
     for(const e of data)  {
          if(e.isNew) {
           const  {id, ...result} = e;
           mapData.push(result);
           } else {
            mapData.push(e);
           }
        }

        if(data.length > 0) {
          const newdata = {Lessors: mapData};
          this.submitevent.emit(newdata)
        } else {
          this.matSnackBar.open('You dont have any item in the list to submit!', 'Exit', {duration: 3000});
        }
      }
    }
